<div [kalLoading]="loading">

    <kal-form-field>

        <kal-select [formControl]="ibanControl"
                    [label]="label"
                    [placeholder]="placeholder">

            @for(iban of ibansList; track iban.IdRib) {
                <kal-option [value]="iban.IdRib">
                    {{iban.CodePaysIban + iban.CleIban + ' ' + iban.BBAN | iban}}
                </kal-option>
            }

        </kal-select>

    </kal-form-field>

</div>
